import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { TranslocoService } from '@jsverse/transloco';
import { CurrentPlan } from '../../../core/models/corporate/current-plan.model';
import { Plan } from '../../../core/models/corporate/plan.model';
import { trialRemainingLabel } from '../../utils/trial-remaining.util';

@Component({
  selector: 'app-plan-view-price',
  standalone: false,
  templateUrl: './plan-view-price.component.html',
  styleUrl: './plan-view-price.component.scss'
})
export class PlanViewPriceComponent {

  @Input() currentSubscription: CurrentPlan | null = null;
  @Input() planView: Plan | null = null;
  @Output() cancelSubscriptionEvent = new EventEmitter<void>();

  constructor(
    private confirmationService: ConfirmationService,
    private transloco: TranslocoService,
  ) { }

  cancelSubscription() {
    if (this.currentSubscription) {
      this.confirmCancelSubscription();
    }
  }

  confirmCancelSubscription() {
    this.confirmationService.confirm({
      message: this.transloco.translate('plan.cancelConfirm'),
      accept: () => {
        this.cancelSubscriptionEvent.emit();
      }
    });
  }

  // Getters para manejar información de trial
  get isTrial(): boolean {
    return this.currentSubscription?.isTrial || false;
  }

  get trialTimeRemaining() {
    return this.currentSubscription?.trialTimeRemaining;
  }

  get isTrialExpiringSoon(): boolean {
    return this.trialTimeRemaining?.isExpiringSoon || false;
  }

  get trialDaysRemaining(): number {
    return this.trialTimeRemaining?.days || 0;
  }

  get requiresPaymentMethod(): boolean {
    return this.currentSubscription?.requiresPaymentMethod || false;
  }

  /**
   * Nombre legible del plan. Antes el template mostraba `planType`/`plan?.type`
   * (el slug interno, ej. "corporate") en vez del nombre visible — bug
   * preexistente que se hizo evidente al agregar el copy nuevo ("Max").
   */
  get planDisplayName(): string {
    if (this.currentSubscription && this.currentSubscription.planType !== 'none') {
      return this.currentSubscription.planName;
    }
    return this.planView?.name ?? '';
  }

  get displayPrice(): number {
    return (this.currentSubscription ? this.currentSubscription.price : this.planView?.price) ?? 0;
  }

  get displayCurrency(): 'usd' | 'cop' {
    return (this.currentSubscription ? this.currentSubscription.currency : this.planView?.currency) ?? 'cop';
  }

  getTrialStatusText(): string {
    if (!this.isTrial) return '';
    return trialRemainingLabel(this.transloco, this.trialDaysRemaining, this.trialTimeRemaining?.hours || 0);
  }
}